// import axios,{post, put, get} from "axios";
import axios from "axios";
// import post from "axios";
import { post, put, get } from "axios";

export const apis = [
  //login
  {
    name: "login",
    method: "POST",
    endpoint: "/security/login",
  },
  {
    name: "personnelList",
    method: "POST",
    endpoint: "/person/findbyfullname",
  },
  {
    name: "personnelByPerson",
    method: "POST",
    endpoint: "/report/personnelbyperson",
  },
  {
    name: "departmentLists",
    method: "GET",
    endpoint: "/department/lists",
  },
  {
    name: "workingday2",
    method: "POST",
    endpoint: "/report/workingday2",
  },
  {
    name: "personnelbydepartment",
    method: "POST",
    endpoint: "/report/personnelbydepartment",
  },
  {
    name: "absenteeism",
    method: "POST",
    endpoint: "/report/absenteeism",
  },
  {
    name: "departmentstatistics",
    method: "POST",
    endpoint: "/report/departmentstatistics",
  },
  {
    name: "departmentstatistics2",
    method: "POST",
    endpoint: "/report/departmentstatistics2",
  },
  {
    name:"departmentdetail",
    method:"POST",
    endpoint:"/report/departmentdetail",
  },
  {
    name:"userlists",
    method:"GET",
    endpoint:"/user/lists",
  },
  {
    name:"personnelexcel",
    method:"POST",
    endpoint:"/report/personnelbyperson/printExcel",
  },
  {
    name:"personnelpdf",
    method:"POST",
    endpoint:"/report/personnelbyperson/printPDF"
  },
  {
    name:"departmentexcel",
    method:"POST",
    endpoint:"/report/personnelbydepartment/printExcel",
  },
  {
    name:"absenteeismexcel",
    method:"POST",
    endpoint:"/report/absenteeism/printExcel",
  },
  {
    name:"depstatisticexcel",
    method:"POST",
    endpoint:"/report/departmentstatistics/printExcel2",
  },
  {
    name:"depstadetailsexcel",
    method:"POST",
    endpoint:"/report/departmentdetail/printExcel",
  },
  {
    name:"departmentcreate",
    method:"POST",
    endpoint:"/department/create"
  },
  {
    name:"departmentupdate",
    method:"PUT",
    endpoint:"/department/update/id"
  },
  {
    name:"getdepartmentbyid",
    method:"GET",
    endpoint:"/department/id"
  },
  {
    name:"getdepartmentZktecobyid",
    method:"GET",
    endpoint:"/department/get/zkteco/id"
  },
  {
    name:"getpersons",
    method:"GET",
    endpoint:"/person/lists"
  },
  {
    name:"personscreate",
    method:"POST",
    endpoint:"/person/create"
  },
  {
    name:"personsupdate",
    method:"PUT",
    endpoint:"/person/update/id"
  },
  {
    name:"getpersonbyid",
    method:"GET",
    endpoint:"/person/id"
  },
  {
    name:"reasonadd",
    method:"POST",
    endpoint:"/report/addReasonLate"
  },
  {
    name:"getUserLists",
    method:"GET",
    endpoint:"/user/lists"
  },
  {
    name:"getpersonzktecobyid",
    method:"GET",
    endpoint:"/person/get/zkteco/id"
  },
  {
    name:"getAperson",
    method:"GET",
    endpoint:"/person/sid/{sid}"
  },
  {
    name:"getAttendanceByName",
    method:"POST",
    endpoint:"/attendance/findAttendanceByName"
  },
  {
    name:"getAttendanceMonthly",
    method:"POST",
    endpoint:"/attendance/findAttendanceMonthly"
  },
  {
    name:"getAttendanceExcel",
    method:"POST",
    endpoint:"/attendance/printExcel"
  },
  {
    name:"getAttendanceExcelMonth",
    method:"POST",
    endpoint:"/attendance/printExcelMonth"
  },
];

// export const apiToken = { token: "", ip: "192.168.5.136" };
export const apiToken = { token: "", ip: "facetime2.hslnet.my" };
export const ApiURL = `https://${apiToken.ip}/api/public`;

// export const ApiURL = "http://" + apiToken.ip + "/paloh/api/public/index.php";
export const setApiToken = async (token) => {
  apiToken.token = token;
};

export const apiServices = async (service, opts) => {
  const api = apis.find((api) => api.name === service);
  let config = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "true",
    "Access-Control-Allow-Credentials": "true",
  };
  if (apiToken?.token) {
    config.headers = { "X-Auth-Token": `${apiToken.token}` };
  }
  // console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX");
  // console.log(config);
  // console.log(api);
  if (api === undefined) {
    if (opts?.onFailure !== undefined) opts.onFailure("API Not Found");
    return;
  }
  try {
    const method = api.method;
    let endpoint = api.endpoint;
    if (opts?.replace !== undefined) {
      if (Array.isArray(opts.replace)) {
        opts.replace.forEach((replace) => {
          endpoint = endpoint.replace(replace.search, replace.replace);
        });
      } else {
        endpoint = endpoint.replace(
          opts?.replace.search,
          opts?.replace.replace
        );
      }
    }

    // console.log(endpoint);
    let response = "";
    let data = {};

    if (method === "GET") {
      response = await get(ApiURL + endpoint, config);
    } else if (method === "POST") {
      const body = opts?.body === undefined ? {} : opts?.body;
      response = await post(ApiURL + endpoint, body, config);
    } else if (method === "PUT") {
      const body = opts?.body === undefined ? {} : opts?.body;
      response = await put(ApiURL + endpoint, body, config);
    }

    return response;
  } catch (error) {
    console.log(error);
  }
};
